import {ref, Ref} from '@vue/composition-api';

type ExportFormLocalCallback = () => void;

export class EditorExportFormLocalControllerClass {
	private static _instance: EditorExportFormLocalControllerClass;
	static instance() {
		return (this._instance = this._instance || new EditorExportFormLocalControllerClass());
	}

	private constructor() {}

	private _displayed!: Ref<boolean>;
	private _resolve: ExportFormLocalCallback | undefined;
	init() {
		this._displayed = ref(false);
	}

	// getters
	displayed() {
		return this._displayed.value;
	}

	// mutations
	display(): Promise<void> {
		this._displayed.value = true;
		return new Promise((resolve) => {
			this._resolve = resolve;
		});
	}
	confirm() {
		if (this._resolve) {
			this._resolve();
		}
		this._close();
	}
	cancel() {
		this._close();
		this._resolve = undefined;
	}
	private _close() {
		this._displayed.value = false;
	}
}

export const ExportFormLocal = EditorExportFormLocalControllerClass.instance();
